<div class="monthly-payment__banner">
    <img src="./assets/img/wallet-icon.png" alt="Tarjeta crédito">
    <p>Registra tu tarjeta débito o crédito, así, <b>cada mes debitaremos el valor de tu seguro</b> para que siempre
        esté al día. Conoce los <a (click)="openTermsModal()">Términos y condiciones</a>.</p>

    <div class="form-check form-switch">
        <input
          class="form-check-input"
          type="checkbox"
          role="switch"
          id="subscriptionSwitch"
          [checked]="isSubscriptionActive()"
          [disabled]="isDisabled()"
          (change)="toggleSubscription()"
        />
      </div>
</div>

<app-subscription-terms-conditions-modal
  [isVisible]="isTermsModalVisible"
  (accepted)="closeTermsModal()"
  (closed)="closeTermsModal()">
</app-subscription-terms-conditions-modal>